import { getData, ifOkToJson, isDataFine, post } from "./index";
import { httpUrl } from "./httpUrl";

let baseUrl = httpUrl.host + "/gy-apartment";

class TreeApi {
  getYqInfo() {
    return post(`${baseUrl}/gyInfo/getYqInfo`, {})
      .then(ifOkToJson)
      .then(getData);
  }
  getBuildingList() {
    return post(`${baseUrl}/building/getBuildingList`, {})
      .then(ifOkToJson)
      .then(getData);
  }
  getVacancyRoomInfo(id) {
    if (id) {
      return post(`${baseUrl}/roomInfo/getAllRoomInfo/${id}`, {})
        .then(ifOkToJson)
        .then(getData);
    } else {
      return post(`${baseUrl}/roomInfo/getAllRoomInfo`, {})
        .then(ifOkToJson)
        .then(getData);
    }
    // if (id) {
    //   return post(`${baseUrl}/feign/roomInfo/getVacancyRoomInfo/${id}`, {})
    //     .then(ifOkToJson)
    //     .then(getData)
    // } else {
    //   return post(`${baseUrl}/feign/roomInfo/getVacancyRoomInfo`, {})
    //     .then(ifOkToJson)
    //     .then(getData)
    // }
  }
}

const treeApi = new TreeApi();
export default treeApi;
export { treeApi };



// WEBPACK FOOTER //
// ./src/view/api/ElectronicTreeApi.js